import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

ChargePointSetLimitPowerView.propTypes = {
  title: PropTypes.string,
  contentEl: PropTypes.element,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  iconEl: PropTypes.element,
  chargePointDetail: PropTypes.object,
};

function ChargePointSetLimitPowerView({
  title = '',
  contentEl,
  onCancel,
  onConfirm,
  iconEl,
  chargePointDetail,
}) {
  // MARK: ---- PROPERTIES ----
  const [inputValue, setInputValue] = useState('');
  useEffect(() => {
    const powerLimit = chargePointDetail?.powerLimit;
    setInputValue(!_.isNull(powerLimit) ? _.toString(powerLimit / 1000) : '');
  }, chargePointDetail);

  // MARK: ---- METHODS ----
  const handleSubmit = () => {
    const iInputValue = inputValue ? _.toNumber(inputValue.replace(',', '.')) * 1000 : null;
    if (onConfirm) {
      onConfirm(iInputValue);
    }
  };

  return (
    <div>
      <div className="d-flex flex-column align-items-center justify-content-center text-center p-3">
        {/* icon */}
        {iconEl && <div className="mb-4">{iconEl}</div>}

        <span style={UIHelper.buildFontStyle('600', '16px', AppColors.gray[800])}>{title}</span>
        <span style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>{contentEl}</span>

        {/* input */}
        <div className="w-100 mt-4">
          <div className="text-left">{UIHelper.buildFormLabel('Nhập công suất giới hạn')}</div>
          <KTFormInput
            name="powerLimit"
            placeholder="Nhập công suất giới hạn"
            type={KTFormInputType.currency}
            unit="kW"
            value={inputValue}
            onChange={(value) => setInputValue(value)}
          />
        </div>
      </div>

      {/* footer */}
      <div
        className="d-flex align-items-center gap-3 p-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
        {UIHelper.buildGreenButton('Thiết lập', handleSubmit, null, true)}
      </div>
    </div>
  );
}

export default ChargePointSetLimitPowerView;
